<template>
  <div>
    <GalleryFormGroup
        :value="value.image_id"
        name="image_id"
        label="Image"
        :error="(errors.image_id || [])[0]"
        @input="emit('image_id', $event)"
    />
  </div>
</template>

<script>
import GalleryFormGroup from "../../../../components/FormGroups/Block/Gallery"

export default {
  components: {GalleryFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    }
  },

  methods: {
    emit(key, value) {
      this.$emit('input', {...this.value, [key]: value})
    },
  }
}
</script>
